export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
        name: {
            type: String,
            required: true,
        },
        shouldTrim: {
            type: Boolean,
            required: false,
            default: true,
        },
        isMdField: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasGeneralError: {
            type: Boolean,
            required: false,
            default: false,
        },
        inputSanitationRegex: {
            type: RegExp,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            inputValue: '',
        };
    },
    watch: {
        value(newValue: any) {
            (<any> this).inputValue = newValue;
        },
    },
    methods: {
        onInput(e: any) {
            const self = <any> this;
            const value = self.getValue(e);
            self.isDirty = true;
            self.inputValue = value;
            self.$emit('input', value);
            self.$emit('valueChanged', value, self.name);
        },
        onBlur() {
            const self = <any> this;
            self.$emit('blur', self.name, self.inputValue, self.isDirty);
        },
        getValue(this: any, e: any): any {
            let value = e.target.value;
            if (this.shouldTrim) {
                value = value.trim();
            }
            if (this.inputSanitationRegex) {
                value = value.replace(this.inputSanitationRegex, '');
            }
            return value;
        },
    },
};
